export enum TopFiltersEnum {
    // todayDeals = 'Today\'s Deals',
    priceDrop = 'Price Drop',
    justLaunched = 'Just Launched',
    justSold = 'Just Sold',
    liveOffers = 'Live Offers'
  }
